import Vue from 'vue';

export default Vue.extend({
  functional: true,
  render(h, { children, props }) {
    if (props.showParent) {
      const Comp = props.parentComp;
      return h(Comp, {
        class: props.parentClass,
      }, children);
    }
    return children;
  },
});